import { useNavigate } from "react-router-dom";
import { Fingerprint, Magnet, Waves, Orbit, ScanFace, Snowflake, Layers, Box, Disc3, Droplets, Zap, Atom, ArrowUpRight, FolderOpen, Trash2 } from "lucide-react";
import { INSTRUMENTS } from "../lab/instruments";
import { labStore, useSaved } from "../lab/store";

const ICONS = { Fingerprint, Magnet, Waves, Orbit, ScanFace, Snowflake, Layers, Box, Disc3, Droplets, Zap, Atom };

const Bay = ({ ins, i, saved, onOpen }) => {
  const Icon = ICONS[ins.icon], live = !!labStore.live[ins.id];
  return (
    <article className="bay holo" onClick={onOpen} style={{ "--accent": ins.accent, animationDelay: `${i * 60}ms` }} data-testid={`instrument-card-${ins.id}`}>
      <div className="bay-top">
        <span className="bay-code">{ins.code}</span>
        <span className={`bay-status ${live ? "is-live" : ""}`}>{live ? "SESSION ACTIVE" : "STANDBY"}</span>
      </div>
      <div className="bay-core"><span className="bay-ring" /><span className="bay-ring r2" /><Icon size={30} strokeWidth={1.4} /></div>
      <h3 className="bay-name">{ins.name}</h3>
      <p className="bay-purpose">{ins.purpose}</p>
      <div className="bay-foot">
        <span className="bay-saved" data-testid={`instrument-saved-count-${ins.id}`}>{saved} saved</span>
        <button className="bay-open" onClick={(e) => { e.stopPropagation(); onOpen(); }} data-testid={`open-instrument-${ins.id}`}>Open experiment <ArrowUpRight size={14} /></button>
      </div>
    </article>
  );
};

export default function LabDashboard() {
  const nav = useNavigate(), saved = useSaved();
  const open = (id) => nav(`/instrument/${id}`);
  return (
    <div className="dash-root" data-testid="lab-dashboard">
      <div className="dash-sky" /><div className="dash-floor" /><div className="lab-noise" /><div className="lab-streak" />
      <header className="dash-head">
        <div className="flex items-center gap-4">
          <div className="cube-wrap big"><div className="cube"><i /><i /><i /><i /><i /><i /><b /></div></div>
          <div>
            <div className="hud-kicker">SUPRA-SCIENCE DIVISION <em>//</em> SECTOR 7 · CLEARANCE OMEGA</div>
            <h1 className="dash-title holo-text" data-testid="dashboard-title">Digital Matter Lab</h1>
          </div>
        </div>
        <div className="flex gap-2">
          <div className="hud-stat"><span className="hud-stat-label">Instruments</span><span className="hud-stat-value">{INSTRUMENTS.length}</span></div>
          <div className="hud-stat"><span className="hud-stat-label">Saved runs</span><span className="hud-stat-value" data-testid="dashboard-saved-total">{saved.length}</span></div>
          <div className="hud-badge">ONLINE</div>
        </div>
      </header>
      <p className="dash-lede">A laboratory of independent machines. Each instrument has its own simulation engine, surface, controls and camera — choose a bay to begin an experiment.</p>
      <main className="dash-grid" data-testid="instrument-grid">
        {INSTRUMENTS.map((ins, i) => <Bay key={ins.id} ins={ins} i={i} saved={saved.filter((s) => s.instrument === ins.id).length} onOpen={() => open(ins.id)} />)}
      </main>
      {saved.length > 0 && (
        <section className="dash-saved holo" data-testid="dashboard-saved-list">
          <h3 className="panel-title">Experiment archive · this session</h3>
          {saved.map((s) => (
            <div key={s.key} className="saved-row">
              <FolderOpen size={14} /><span className="flex-1">{s.title}</span><span className="ctl-val">{s.at.toLocaleTimeString()}</span>
              <button className="act-btn" onClick={() => open(s.instrument)} data-testid={`dashboard-open-${s.key}`}>Open</button>
              <button className="icon-btn" onClick={() => labStore.remove(s.key)} aria-label="Delete" data-testid={`dashboard-delete-${s.key}`}><Trash2 size={13} /></button>
            </div>
          ))}
        </section>
      )}
    </div>
  );
}
